import React, { useState } from 'react';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import { CreateRequeteDialog } from './CreateRequeteDialog';
import { SearchIcon, FilterIcon, MapPinIcon, MapIcon, TableIcon, FolderIcon, ChevronLeftIcon, ChevronRightIcon, ChevronsUpDownIcon, PlusIcon, SettingsIcon, XIcon, PaperclipIcon, CheckSquareIcon, SquareIcon, LinkIcon, TagIcon, FileTextIcon, PrinterIcon, SendIcon, LockIcon, BellIcon, CheckIcon } from 'lucide-react';
type ViewMode = 'list' | 'map';
/** Citizen-facing tabs on the left pane. */
type LeftTab = 'infos' | 'messages';
/** Internal tabs on the right pane. */
type RightTab = 'gestion' | 'collaboration' | 'historique';
type Status = 'Nouvelle demande' | 'En Cours' | 'Complété' | 'En Attente' | 'Reçue';
interface Request {
  id: string;
  subject: string;
  category: string;
  reqId: string;
  location: string;
  date: string;
  status: Status;
  department: string;
  requester: {
    name: string;
    initials: string;
    color: string;
  };
  slaDate: string;
}
const MOCK_REQUESTS: Request[] = [{
  id: '1',
  subject: 'Divers',
  category: 'Voirie et infrastructures routi...',
  reqId: 'R-101',
  location: '1520, 1 ère Rue, Richelieu,...',
  date: '8 juin 2026',
  status: 'Nouvelle demande',
  department: 'Service Des Travaux Publics',
  requester: {
    name: 'Nathalie Ouellet',
    initials: 'NO',
    color: 'bg-[#4F46E5]'
  },
  slaDate: '13 juin 2026'
}, {
  id: '2',
  subject: 'Bâtiment',
  category: 'Bâtiment',
  reqId: 'R-100',
  location: '205, Avenue 8e, Richelie...',
  date: '8 juin 2026',
  status: 'Nouvelle demande',
  department: 'Service Des Travaux Publics',
  requester: {
    name: 'Nathalie Ouellet',
    initials: 'NO',
    color: 'bg-[#4F46E5]'
  },
  slaDate: '8 juillet 2026'
}, {
  id: '3',
  subject: 'Nid-de-poule - trait...',
  category: 'Voirie et infrastructures routi...',
  reqId: 'R-99',
  location: '2907, Rang de la Savane, ...',
  date: '8 juin 2026',
  status: 'Nouvelle demande',
  department: 'Service Des Travaux Publics',
  requester: {
    name: 'Caroline Nadeau',
    initials: 'CN',
    color: 'bg-[#4F46E5]'
  },
  slaDate: '13 juin 2026'
}, {
  id: '4',
  subject: 'Divers',
  category: 'Voirie et infrastructures routi...',
  reqId: 'R-98',
  location: '32, Place Rouville-Tessier,...',
  date: '8 juin 2026',
  status: 'Complété',
  department: 'Service Des Travaux Publics',
  requester: {
    name: 'Nathalie Ouellet',
    initials: 'NO',
    color: 'bg-[#4F46E5]'
  },
  slaDate: '13 juin 2026'
}, {
  id: '5',
  subject: 'Divers',
  category: 'Voirie et infrastructures routi...',
  reqId: 'R-97',
  location: '700, Rue Martel, Richelie...',
  date: '4 juin 2026',
  status: 'En Cours',
  department: 'Service Des Travaux Publics',
  requester: {
    name: 'Nathalie Ouellet',
    initials: 'NO',
    color: 'bg-[#4F46E5]'
  },
  slaDate: '9 juin 2026'
}, {
  id: '6',
  subject: 'Plateaux sportifs - t...',
  category: 'Parcs et espaces récréatifs',
  reqId: 'R-96',
  location: '900, Rue des Oblats, Ric...',
  date: '3 juin 2026',
  status: 'Complété',
  department: 'Service Des Travaux Publics',
  requester: {
    name: 'Nathalie Ouellet',
    initials: 'NO',
    color: 'bg-[#4F46E5]'
  },
  slaDate: '8 juin 2026'
}, {
  id: '7',
  subject: 'Refoulement égout...',
  category: 'Eau potable et égout',
  reqId: 'R-95',
  location: '192, Rue des Érables, Ric...',
  date: '3 juin 2026',
  status: 'Nouvelle demande',
  department: 'Service Des Travaux Publics',
  requester: {
    name: 'Éric Robin',
    initials: 'ÉR',
    color: 'bg-[#4F46E5]'
  },
  slaDate: '4 juin 2026'
}];
const getStatusColor = (status: Status) => {
  switch (status) {
    case 'Nouvelle demande':
      return 'bg-slate-200 text-slate-700';
    case 'En Cours':
      return 'bg-indigo-100 text-indigo-700';
    case 'Complété':
      return 'bg-indigo-100 text-indigo-700';
    case 'En Attente':
      return 'bg-orange-100 text-orange-700';
    case 'Reçue':
      return 'bg-slate-100 text-slate-600';
    default:
      return 'bg-slate-100 text-slate-700';
  }
};
const getStatusDot = (status: Status) => {
  switch (status) {
    case 'Nouvelle demande':
      return 'bg-slate-400';
    case 'En Cours':
      return 'bg-[#4F46E5]';
    case 'Complété':
      return 'bg-[#4F46E5]';
    case 'En Attente':
      return 'bg-orange-500';
    case 'Reçue':
      return 'bg-slate-400';
    default:
      return 'bg-slate-400';
  }
};
// Request locations around Brossard, QC
const MAP_MARKERS: {
  reqId: string;
  subject: string;
  category: string;
  position: [number, number];
}[] = [{
  reqId: 'R-127',
  subject: 'Taxation',
  category: 'Administration',
  position: [45.4528, -73.4622]
}, {
  reqId: 'R-104',
  subject: 'Lampadaire défectueux',
  category: 'Éclairage public',
  position: [45.4468, -73.4698]
}, {
  reqId: 'R-70',
  subject: 'Eau potable (qualité)',
  category: 'Eau potable et égout',
  position: [45.4552, -73.4578]
}, {
  reqId: 'R-103',
  subject: 'Feux de circulation',
  category: 'Éclairage public',
  position: [45.4438, -73.4728]
}, {
  reqId: 'R-57',
  subject: 'Lampadaire défectueux',
  category: 'Éclairage public',
  position: [45.4488, -73.4548]
}];
// Custom indigo map marker
const requestMarkerIcon = L.divIcon({
  className: '',
  html: `<div style="display:flex;align-items:center;justify-content:center;width:28px;height:28px;border-radius:9999px;background:#4F46E5;box-shadow:0 2px 6px rgba(0,0,0,0.3);border:2px solid white;"><svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M4 20h16a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13c0 1.1.9 2 2 2Z"/></svg></div>`,
  iconSize: [28, 28],
  iconAnchor: [14, 14],
  popupAnchor: [0, -14]
});
export function RequetesGerer() {
  const [viewMode, setViewMode] = useState<ViewMode>('list');
  const [selectedRequest, setSelectedRequest] = useState<Request | null>(null);
  const [showCreate, setShowCreate] = useState(false);
  const [leftTab, setLeftTab] = useState<LeftTab>('infos');
  const [rightTab, setRightTab] = useState<RightTab>('gestion');
  const [draft, setDraft] = useState('');
  const [noteDraft, setNoteDraft] = useState('');
  if (selectedRequest) {
    return <div className="bg-slate-50 -mx-4 sm:-mx-6 lg:-mx-8 -my-8 min-h-screen flex" data-id="element-5135" data-mp="34zy5uk5fm82z">
        {/* Left Pane - Citizen Visible */}
        <div className="w-1/2 border-r border-slate-200 bg-white flex flex-col" data-id="element-5136" data-mp="1anri6lvcpyts">
          <div className="p-4 border-b border-slate-200 flex items-center gap-2 text-slate-500 text-sm font-medium" data-id="element-5137" data-mp="1apuhxxmb36bp">
            <div className="w-4 h-4 rounded-full border-2 border-slate-300 flex items-center justify-center" data-id="element-5138" data-mp="ye1ul6b7aahb">
              <div className="w-1.5 h-1.5 bg-slate-300 rounded-full" data-id="element-5139" data-mp="tdw1dlpa8fx4"></div>
            </div>
            Visible par le citoyen
          </div>

          <div className="px-6 pt-4 border-b border-slate-200 flex gap-6" data-id="element-5140" data-mp="ohfcgpa9dxiz">
            <button onClick={() => setLeftTab('infos')} className={`pb-3 border-b-2 font-semibold text-sm transition-colors ${leftTab === 'infos' ? 'border-[#4F46E5] text-[#4F46E5]' : 'border-transparent text-slate-500 hover:text-slate-700'}`} data-id="element-5141" data-mp="1m21nabs2oayj">
              Infos
            </button>
            <button onClick={() => setLeftTab('messages')} className={`pb-3 border-b-2 font-semibold text-sm transition-colors flex items-center gap-2 ${leftTab === 'messages' ? 'border-[#4F46E5] text-[#4F46E5]' : 'border-transparent text-slate-500 hover:text-slate-700'}`} data-id="element-5142" data-mp="r2uellaukeo">
              Messages
              <span className="px-1.5 py-0.5 rounded-full bg-[#4F46E5] text-white text-[10px] font-bold" data-id="element-5143" data-mp="cfpf1rzn0ly3">
                1
              </span>
            </button>
          </div>

          {leftTab === 'messages' && <>
              <div className="p-6 overflow-y-auto flex-1 space-y-5" data-id="element-5144" data-mp="147wnw68wiu1x">
                <div className="flex items-center gap-2 text-xs text-slate-500 bg-slate-50 border border-slate-200 rounded-lg px-3 py-2" data-id="element-5145" data-mp="19459o2hltli2">
                  <BellIcon className="w-3.5 h-3.5 text-slate-400 flex-shrink-0" data-id="element-5146" data-mp="zeu0kfupwgu6" />
                  Nathalie Ouellet reçoit chaque message par courriel et
                  notification bciti+.
                </div>

                <div className="text-center" data-id="element-5147" data-mp="1rvoaq3s2iphg">
                  <span className="text-[11px] font-semibold text-slate-400 uppercase tracking-wider" data-id="element-5148" data-mp="1rwftge0kgsqb">
                    19 mai 2026
                  </span>
                </div>

                {/* Citizen message */}
                <div className="flex gap-3" data-id="element-5149" data-mp="37kme8bqv3j2j">
                  <div className="w-8 h-8 rounded-full bg-[#4F46E5] text-white flex items-center justify-center text-xs font-bold flex-shrink-0" data-id="element-5150" data-mp="3mabiwgy5y57k">
                    NO
                  </div>
                  <div className="flex-1 min-w-0" data-id="element-5151" data-mp="2tlw9qb1pqh45">
                    <div className="bg-slate-50 border border-slate-200 rounded-xl rounded-tl-sm p-3.5 text-sm text-slate-700 leading-relaxed" data-id="element-5152" data-mp="2toiq906l06yi">
                      Bonjour, je voulais savoir si quelqu'un est passé au parc.
                      Les branches sont toujours sur le sentier ce matin et les
                      enfants passent par là pour aller à l'école.
                    </div>
                    <div className="text-[11px] text-slate-400 mt-1" data-id="element-5153" data-mp="iwqw50oj3zto">
                      Nathalie Ouellet · 19 mai, 08:12
                    </div>
                  </div>
                </div>

                {/* Staff reply */}
                <div className="flex gap-3 flex-row-reverse" data-id="element-5154" data-mp="2v5w1irk2rg7q">
                  <div className="w-8 h-8 rounded-full bg-slate-800 text-white flex items-center justify-center text-[10px] font-bold flex-shrink-0" data-id="element-5155" data-mp="2v8ihnfl1741k">
                    JD
                  </div>
                  <div className="flex-1 min-w-0" data-id="element-5156" data-mp="2lei5itrc0yjc">
                    <div className="bg-[#4F46E5] rounded-xl rounded-tr-sm p-3.5 text-sm text-white leading-relaxed" data-id="element-5157" data-mp="2ghrq88ncq6yz">
                      Bonjour Mme Ouellet, merci pour votre signalement. Une
                      équipe des Travaux publics est planifiée pour le
                      ramassage des branches le 21 mai en avant-midi. Les
                      poubelles ont été vidées hier.
                    </div>
                    <div className="text-[11px] text-slate-400 mt-1 text-right flex items-center justify-end gap-1.5" data-id="element-5158" data-mp="5o5hfckmf3yi">
                      Jacques Dubois · 19 mai, 09:47
                      <CheckIcon className="w-3 h-3 text-emerald-500" data-id="element-5159" data-mp="8ao9yg9i0313" />
                      <span className="text-emerald-600 font-medium" data-id="element-5160" data-mp="d8zk6s3pgfju">Lu</span>
                    </div>
                  </div>
                </div>

                <div className="text-center" data-id="element-5161" data-mp="i10sk2xr5m4l">
                  <span className="text-[11px] font-semibold text-slate-400 uppercase tracking-wider" data-id="element-5162" data-mp="mysuzqw0wqn1">
                    20 mai 2026
                  </span>
                </div>

                {/* Automated status message */}
                <div className="flex gap-3" data-id="element-5163" data-mp="3qepvf84duk86">
                  <div className="w-8 h-8 rounded-full bg-slate-100 border border-slate-200 flex items-center justify-center flex-shrink-0" data-id="element-5164" data-mp="3qfrg84b7al33">
                    <BellIcon className="w-3.5 h-3.5 text-slate-400" data-id="element-5165" data-mp="48ucegulnf55" />
                  </div>
                  <div className="flex-1 min-w-0" data-id="element-5166" data-mp="1aon3xxd81v20">
                    <div className="bg-white border border-dashed border-slate-300 rounded-xl p-3.5 text-sm text-slate-600 leading-relaxed" data-id="element-5167" data-mp="1ao3nkl37zeq3">
                      <span className="font-semibold text-slate-700" data-id="element-5168" data-mp="3bqclgjlvdemr">
                        Mise à jour automatique
                      </span>
                      <br data-id="element-5169" data-mp="36r00k4ek6hmt" />
                      Le statut de votre requête est passé à « En cours ».
                      Échéance prévue : 26 mai 2026.
                    </div>
                    <div className="text-[11px] text-slate-400 mt-1" data-id="element-5170" data-mp="3gqqvg7716ynf">
                      Envoyé automatiquement · 20 mai, 07:00
                    </div>
                  </div>
                </div>

                {/* Latest citizen message, unanswered */}
                <div className="flex gap-3" data-id="element-5171" data-mp="31sezy3ve9vxu">
                  <div className="w-8 h-8 rounded-full bg-[#4F46E5] text-white flex items-center justify-center text-xs font-bold flex-shrink-0" data-id="element-5172" data-mp="31t8a7etkb3kq">
                    NO
                  </div>
                  <div className="flex-1 min-w-0" data-id="element-5173" data-mp="29b2o33sm4gv9">
                    <div className="bg-slate-50 border border-slate-200 rounded-xl rounded-tl-sm p-3.5 text-sm text-slate-700 leading-relaxed" data-id="element-5174" data-mp="299rlv8etfh69">
                      Parfait, merci beaucoup pour le suivi rapide !
                    </div>
                    <div className="text-[11px] text-slate-400 mt-1" data-id="element-5175" data-mp="1zxkfk4vskev1">
                      Nathalie Ouellet · 20 mai, 11:23 ·{' '}
                      <span className="text-[#4F46E5] font-medium" data-id="element-5176" data-mp="1la921xg1uksa">
                        Sans réponse
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              {/* Composer */}
              <div className="border-t border-slate-200 p-4 bg-white" data-id="element-5177" data-mp="2iwptwn60k66n">
                <textarea value={draft} onChange={e => setDraft(e.target.value)} rows={3} placeholder="Écrire au citoyen..." className="w-full px-3 py-2.5 border border-slate-200 rounded-lg text-sm resize-none focus:outline-none focus:ring-2 focus:ring-[#4F46E5] focus:border-transparent" data-id="element-5178" data-mp="23yxjg9fbq7zb" />
                <div className="flex items-center justify-between mt-2.5" data-id="element-5179" data-mp="1dpzqqs91lxh2">
                  <div className="flex items-center gap-1" data-id="element-5180" data-mp="1draxn0xsblce">
                    <button aria-label="Joindre un fichier" className="p-2 rounded-lg text-slate-400 hover:text-[#4F46E5] hover:bg-indigo-50 transition-colors" data-id="element-5181" data-mp="18y8apbnija56">
                      <PaperclipIcon className="w-4 h-4" data-id="element-5182" data-mp="z2mzqo0guzja" />
                    </button>
                    <span className="text-xs text-slate-400" data-id="element-5183" data-mp="1wnj5mci6mabe">
                      Visible par le citoyen
                    </span>
                  </div>
                  <button disabled={!draft.trim()} onClick={() => setDraft('')} className="inline-flex items-center gap-2 px-4 py-2 bg-[#4F46E5] text-white text-sm font-semibold rounded-lg hover:bg-[#4338CA] disabled:opacity-40 disabled:cursor-not-allowed transition-colors" data-id="element-5184" data-mp="1mqefy2p4nwpu">
                    <SendIcon className="w-4 h-4" data-id="element-5185" data-mp="6b3dev8kp5d2" />
                    Envoyer
                  </button>
                </div>
              </div>
            </>}

          <div className={`p-6 overflow-y-auto flex-1 ${leftTab === 'infos' ? '' : 'hidden'}`} data-id="element-5186" data-mp="2mzw89pzzujuj">
            <div className="flex justify-between items-start mb-8" data-id="element-5187" data-mp="2rwcz4rykvcbb">
              <div className="flex gap-4" data-id="element-5188" data-mp="2woxn3cusyv6x">
                <div className="w-12 h-12 rounded-xl bg-slate-50 border border-slate-200 flex items-center justify-center flex-shrink-0" data-id="element-5189" data-mp="2wqqwv10ppvj5">
                  <FolderIcon className="w-6 h-6 text-[#4F46E5]" data-id="element-5190" data-mp="35ot4w0iv5ofx" />
                </div>
                <div data-id="element-5191" data-mp="3aoffe27b4ql1">
                  <div className="flex items-center gap-2" data-id="element-5192" data-mp="3ao5peem9ijfc">
                    <h2 className="text-xl font-bold text-slate-900" data-id="element-5193" data-mp="3ammaosg98gfo">
                      Entretien des parcs
                    </h2>
                    <ChevronLeftIcon className="w-4 h-4 text-slate-400 rotate-[-90deg]" data-id="element-5194" data-mp="1gb7j063oo6xa" />
                  </div>
                  <div className="text-sm text-slate-500 mt-1 flex items-center gap-2" data-id="element-5195" data-mp="1lak34j366zw6">
                    <span className="bg-slate-100 px-2 py-0.5 rounded text-xs font-medium border border-slate-200" data-id="element-5196" data-mp="1d81ft47g65x1">
                      R-71
                    </span>
                    <span data-id="element-5197" data-mp="1n6z7gg066fk9">Parcs et espaces récréatifs</span>
                  </div>
                  <div className="text-sm text-slate-400 mt-1 ml-10 border-l-2 border-slate-200 pl-2" data-id="element-5198" data-mp="1n4mjnm7qdaza">
                    Service Des Travaux Publics
                  </div>
                </div>
              </div>
              <div className={`px-3 py-1 rounded-full text-sm font-medium flex items-center gap-2 ${getStatusColor('En Cours')}`} data-id="element-5199" data-mp="1s627tn57fxlw">
                <div className={`w-2 h-2 rounded-full ${getStatusDot('En Cours')}`} data-id="element-5200" data-mp="25wp315brb5d8"></div>
                En Cours
              </div>
            </div>

            <div className="mb-8" data-id="element-5201" data-mp="2fw67xkj6pf85">
              <h3 className="text-xs font-bold text-slate-400 uppercase tracking-wider mb-3" data-id="element-5202" data-mp="2fta7npjv6egj">
                DESCRIPTION
              </h3>
              <div className="p-4 rounded-xl border border-slate-200 bg-white text-slate-700 text-sm leading-relaxed" data-id="element-5203" data-mp="2ui3hos6isow6">
                Le parc près de la rue Principale nécessite un entretien urgent.
                Les poubelles débordent et il y a des branches cassées sur le
                sentier principal suite à la tempête d'hier soir. Cela
                représente un danger pour les piétons et les cyclistes.
              </div>
            </div>

            <div className="grid grid-cols-2 gap-8 mb-8" data-id="element-5204" data-mp="2asjh250l6mz8">
              <div data-id="element-5205" data-mp="2flvzfxeo9xjj">
                <h3 className="text-xs font-bold text-slate-400 uppercase tracking-wider mb-3" data-id="element-5206" data-mp="2fn7562rohfda">
                  DEMANDEUR
                </h3>
                <div className="flex items-start gap-3" data-id="element-5207" data-mp="26s99wp125qis">
                  <div className="w-8 h-8 rounded-full bg-[#4F46E5] text-white flex items-center justify-center text-xs font-bold flex-shrink-0 mt-0.5" data-id="element-5208" data-mp="26qogx3ue6fn1">
                    NO
                  </div>
                  <div data-id="element-5209" data-mp="1wwpctzarclsg">
                    <div className="font-semibold text-slate-900 text-sm" data-id="element-5210" data-mp="2cccnb63dif9x">
                      Nathalie Ouellet
                    </div>
                    <div className="text-sm text-slate-500 mt-0.5" data-id="element-5211" data-mp="28cc7bh0mlw0r">
                      (450) 658-1157
                    </div>
                    <div className="text-sm text-slate-500" data-id="element-5212" data-mp="23e0y98i5npjl">
                      adjointe.tp@ville.richelieu.qc.ca
                    </div>
                  </div>
                </div>
              </div>
              <div data-id="element-5213" data-mp="1tfl7x7qyckb5">
                <h3 className="text-xs font-bold text-slate-400 uppercase tracking-wider mb-3" data-id="element-5214" data-mp="1ona59x4tukew">
                  EMPLACEMENT
                </h3>
                <div className="flex items-start gap-2" data-id="element-5215" data-mp="1klycxjukjl30">
                  <MapPinIcon className="w-4 h-4 text-slate-400 mt-0.5 flex-shrink-0" data-id="element-5216" data-mp="1fmvj6vk1h1ac" />
                  <div data-id="element-5217" data-mp="1amzfkxf97bvb">
                    <div className="text-sm text-slate-700" data-id="element-5218" data-mp="1animzk7a2hv3">
                      200 Boulevard Richelieu
                    </div>
                    <div className="text-sm text-slate-700" data-id="element-5219" data-mp="15oxwichtvcju">
                      Richelieu, J3L 3R1
                    </div>
                    <button className="text-sm text-[#4F46E5] mt-1 hover:underline" data-id="element-5220" data-mp="10jbyoiuhrfz3">
                      Voir sur la carte ▾
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div data-id="element-5221" data-mp="1ahrnug9ykf5y">
              <h3 className="text-xs font-bold text-slate-400 uppercase tracking-wider mb-3" data-id="element-5222" data-mp="1ag6swpjqeu7k">
                PIÈCES JOINTES
              </h3>
              <div className="flex gap-3" data-id="element-5223" data-mp="hsu92n4yh0hy">
                <div className="w-20 h-20 rounded-lg bg-slate-200 overflow-hidden" data-id="element-5224" data-mp="htvtvjbrx1cv">
                  <img src="https://images.unsplash.com/photo-1500382017468-9049fed747ef?w=200&h=200&fit=crop" alt="Parc" className="w-full h-full object-cover" data-id="element-5225" data-mp="mrnm6egbyphl" />
                </div>
                <div className="w-20 h-20 rounded-lg bg-slate-200 overflow-hidden" data-id="element-5226" data-mp="3q6tcuay65q60">
                  <img src="https://images.unsplash.com/photo-1519331379826-f10be5486c6f?w=200&h=200&fit=crop" alt="Parc" className="w-full h-full object-cover" data-id="element-5227" data-mp="3v5mijh77scvm" />
                </div>
                <button className="w-20 h-20 rounded-lg border-2 border-dashed border-slate-300 flex flex-col items-center justify-center text-slate-400 hover:text-[#4F46E5] hover:border-[#4F46E5] transition-colors" data-id="element-5228" data-mp="219wsbtixyg78">
                  <PlusIcon className="w-5 h-5 mb-1" data-id="element-5229" data-mp="18lr7z7vsut7x" />
                  <span className="text-xs font-medium" data-id="element-5230" data-mp="1dirc3d939lwe">Téléverser</span>
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Right Pane - Internal */}
        <div className="w-1/2 bg-slate-50 flex flex-col relative" data-id="element-5231" data-mp="1mc4ed5t1lzv5">
          <button onClick={() => setSelectedRequest(null)} className="absolute top-4 right-4 p-2 text-slate-400 hover:text-slate-600 rounded-lg hover:bg-slate-200 transition-colors z-10" data-id="element-5232" data-mp="1mdfhd3enz3l7">
            <XIcon className="w-5 h-5" data-id="element-5233" data-mp="mbiq03mgk5za" />
          </button>

          <div className="p-4 border-b border-slate-200 flex items-center justify-between text-slate-500 text-sm font-medium bg-white" data-id="element-5234" data-mp="mazi7fqiuxyz">
            <div className="flex items-center gap-2" data-id="element-5235" data-mp="daudxegmkfp1">
              <div className="w-4 h-4 rounded flex items-center justify-center border-2 border-slate-300" data-id="element-5236" data-mp="d99hfjar2moj">
                <div className="w-2 h-2 bg-slate-300 rounded-sm" data-id="element-5237" data-mp="8e3x2owzxg2k"></div>
              </div>
              Interne — non visible par le citoyen
            </div>
            <PrinterIcon className="w-4 h-4 mr-10" data-id="element-5238" data-mp="3urcaetjwu1lm" />
          </div>

          <div className="px-6 pt-4 border-b border-slate-200 flex gap-6 bg-white" data-id="element-5239" data-mp="3pshhgys8awns">
            {[{
            id: 'gestion' as const,
            label: 'Gestion'
          }, {
            id: 'collaboration' as const,
            label: 'Collaboration'
          }, {
            id: 'historique' as const,
            label: 'Historique'
          }].map(tab => <button key={tab.id} onClick={() => setRightTab(tab.id)} className={`pb-3 border-b-2 font-semibold text-sm transition-colors ${rightTab === tab.id ? 'border-[#4F46E5] text-[#4F46E5]' : 'border-transparent text-slate-500 hover:text-slate-700'}`} data-id="element-5240" data-mp="3bthzub34vi14">
                {tab.label}
              </button>)}
          </div>

          {rightTab === 'collaboration' && <div className="p-6 overflow-y-auto flex-1 space-y-6" data-id="element-5241" data-mp="3puox1dygawri">
              <div className="bg-white rounded-xl border border-slate-200 p-5" data-id="element-5242" data-mp="3ptx0o0x14v06">
                <h3 className="text-xs font-bold text-slate-400 uppercase tracking-wider mb-4" data-id="element-5243" data-mp="3b50xoi9ty86f">
                  INTERVENANTS ASSIGNÉS
                </h3>
                <div className="space-y-3" data-id="element-5244" data-mp="7pbwvr8l1nej">
                  <div className="flex items-center justify-between" data-id="element-5245" data-mp="7nipuau25160">
                    <div className="flex items-center gap-3" data-id="element-5246" data-mp="cg2294h0dq98">
                      <div className="w-8 h-8 rounded-full bg-slate-800 text-white flex items-center justify-center text-[10px] font-bold" data-id="element-5247" data-mp="chn0b42j7rbu">
                        JD
                      </div>
                      <div data-id="element-5248" data-mp="1s5a0tefpfh6v">
                        <div className="text-sm font-semibold text-slate-900" data-id="element-5249" data-mp="26wimxdkeekf9">
                          Jacques Dubois
                        </div>
                        <div className="text-xs text-slate-500" data-id="element-5250" data-mp="21xpiean3a3r8">
                          Travaux publics · Responsable
                        </div>
                      </div>
                    </div>
                    <span className="text-xs font-medium text-emerald-700 bg-emerald-50 px-2 py-1 rounded border border-emerald-100" data-id="element-5251" data-mp="19a33i68evcp2">
                      Actif
                    </span>
                  </div>
                  <div className="flex items-center justify-between" data-id="element-5252" data-mp="1j8soi7vltd9j">
                    <div className="flex items-center gap-3" data-id="element-5253" data-mp="2yllq0q0jtoqb">
                      <div className="w-8 h-8 rounded-full bg-amber-500 text-white flex items-center justify-center text-[10px] font-bold" data-id="element-5254" data-mp="2um4kxxp1atlo">
                        MG
                      </div>
                      <div data-id="element-5255" data-mp="3twtmp9ihspf7">
                        <div className="text-sm font-semibold text-slate-900" data-id="element-5256" data-mp="3ty4q3880zv5s">
                          Martin Gauthier
                        </div>
                        <div className="text-xs text-slate-500" data-id="element-5257" data-mp="7q57ucbagf8t">
                          Parcs et espaces verts · Exécutant
                        </div>
                      </div>
                    </div>
                    <span className="text-xs font-medium text-amber-700 bg-amber-50 px-2 py-1 rounded border border-amber-100" data-id="element-5258" data-mp="gql719l0107v">
                      Intervention prévue
                    </span>
                  </div>
                  <div className="flex items-center justify-between" data-id="element-5259" data-mp="qgwcx1o8tjhe">
                    <div className="flex items-center gap-3" data-id="element-5260" data-mp="vfpsr0r05mkq">
                      <div className="w-8 h-8 rounded-full bg-emerald-500 text-white flex items-center justify-center text-[10px] font-bold" data-id="element-5261" data-mp="vhkcwcug9anr">
                        ST
                      </div>
                      <div data-id="element-5262" data-mp="2kyftjx3tb6a7">
                        <div className="text-sm font-semibold text-slate-900" data-id="element-5263" data-mp="2kuid5j8mcsu0">
                          Sylvie Tremblay
                        </div>
                        <div className="text-xs text-slate-500" data-id="element-5264" data-mp="2azglafmylcnq">
                          Réception · Observatrice
                        </div>
                      </div>
                    </div>
                    <button className="text-xs font-medium text-[#4F46E5] hover:text-[#4338CA]" data-id="element-5265" data-mp="33mb65dnoue1q">
                      Voir
                    </button>
                  </div>
                </div>
                <button className="mt-4 flex items-center gap-2 text-sm font-medium text-[#4F46E5] hover:text-[#4338CA]" data-id="element-5266" data-mp="2twhu6bjmvwwy">
                  <PlusIcon className="w-4 h-4" data-id="element-5267" data-mp="2oy6hzu5v9abk" /> Ajouter un intervenant
                </button>
              </div>

              <div className="bg-white rounded-xl border border-slate-200 p-5" data-id="element-5268" data-mp="3mfx1wca91zc6">
                <div className="flex items-center justify-between gap-3 mb-4" data-id="element-5269" data-mp="3hlswvykjo1dq">
                  <h3 className="text-xs font-bold text-slate-400 uppercase tracking-wider" data-id="element-5270" data-mp="1fqwjptb64rw5">
                    NOTES INTERNES
                  </h3>
                  <span className="inline-flex items-center gap-1 text-[11px] font-medium text-slate-400" data-id="element-5271" data-mp="15zs2so1xmwyo">
                    <LockIcon className="w-3 h-3" data-id="element-5272" data-mp="1aylj0o8lt22j" />
                    Jamais visible par le citoyen
                  </span>
                </div>
                <div className="space-y-3" data-id="element-5273" data-mp="wxiv05y1thoz">
                  <div className="flex gap-3" data-id="element-5274" data-mp="110pam471wl84">
                    <div className="w-7 h-7 rounded-full bg-slate-800 text-white flex items-center justify-center text-[10px] font-bold flex-shrink-0" data-id="element-5275" data-mp="111gtqfjgoqhi">
                      JD
                    </div>
                    <div className="flex-1" data-id="element-5276" data-mp="s0j0msaka3dp">
                      <div className="bg-slate-50 rounded-lg p-3 text-sm text-slate-700 border border-slate-200" data-id="element-5277" data-mp="2hexj4uuzku0r">
                        Visite sur place effectuée. Trois branches de bonne
                        taille à tronçonner, la nacelle n'est pas nécessaire.
                        Prévoir deux employés pour l'avant-midi.
                      </div>
                      <div className="text-[11px] text-slate-400 mt-1" data-id="element-5278" data-mp="5t533fk8h0yh">
                        Jacques Dubois · il y a 2 h
                      </div>
                    </div>
                  </div>
                  <div className="flex gap-3" data-id="element-5279" data-mp="fogm4a2ocuc1">
                    <div className="w-7 h-7 rounded-full bg-amber-500 text-white flex items-center justify-center text-[10px] font-bold flex-shrink-0" data-id="element-5280" data-mp="tgwkuyojm675">
                      MG
                    </div>
                    <div className="flex-1" data-id="element-5281" data-mp="13fvt4g5ebztm">
                      <div className="bg-slate-50 rounded-lg p-3 text-sm text-slate-700 border border-slate-200" data-id="element-5282" data-mp="13ekpcgbyas2i">
                        Le camion nacelle est en réparation jusqu'au 22. On
                        peut quand même y aller au sol comme prévu le 21.
                      </div>
                      <div className="text-[11px] text-slate-400 mt-1" data-id="element-5283" data-mp="30970xgd3s7v7">
                        Martin Gauthier · hier, 16:04
                      </div>
                    </div>
                  </div>
                </div>
                <div className="mt-4 flex items-center gap-2" data-id="element-5284" data-mp="2jbgo5g1yxfjq">
                  <input type="text" value={noteDraft} onChange={e => setNoteDraft(e.target.value)} placeholder="Ajouter une note interne..." className="flex-1 px-3 py-2 border border-slate-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-[#4F46E5] focus:border-transparent" data-id="element-5285" data-mp="2o5ky886j63p1" />
                  <button disabled={!noteDraft.trim()} onClick={() => setNoteDraft('')} className="px-4 py-2 bg-[#0F172A] text-white text-sm font-semibold rounded-lg hover:bg-slate-800 disabled:opacity-40 disabled:cursor-not-allowed transition-colors" data-id="element-5286" data-mp="25c7burgvv5l1">
                    Publier
                  </button>
                </div>
              </div>
            </div>}

          {rightTab === 'historique' && <div className="p-6 overflow-y-auto flex-1" data-id="element-5287" data-mp="1563qkppmlfu4">
              <h3 className="text-xs font-bold text-slate-400 uppercase tracking-wider mb-4" data-id="element-5288" data-mp="10eby29mwt01c">
                JOURNAL D'ACTIVITÉ
              </h3>
              <div className="relative border-l-2 border-slate-200 ml-3 space-y-6" data-id="element-5289" data-mp="vfio2r6tzr5x">
                <div className="relative pl-6" data-id="element-5290" data-mp="qi90zi6wzrl9">
                  <div className="absolute -left-[9px] top-1 w-4 h-4 rounded-full bg-[#4F46E5] border-2 border-white" data-id="element-5291" data-mp="lhuqzulr67kl"></div>
                  <div className="text-sm font-semibold text-slate-900" data-id="element-5292" data-mp="hf7wflxp68jp">
                    Intervention planifiée au 21 mai
                  </div>
                  <div className="text-xs text-slate-500 mt-0.5" data-id="element-5293" data-mp="cizgw7fl8dc0">
                    Martin Gauthier (Parcs et espaces verts)
                  </div>
                  <div className="text-xs text-slate-400 mt-0.5" data-id="element-5294" data-mp="26vz5ur5uyjvy">
                    20 mai 2026 · 16:04
                  </div>
                </div>
                <div className="relative pl-6" data-id="element-5295" data-mp="2x2i903hmj428">
                  <div className="absolute -left-[9px] top-1 w-4 h-4 rounded-full bg-[#4F46E5] border-2 border-white" data-id="element-5296" data-mp="2s4p5xjbmaq66"></div>
                  <div className="text-sm font-semibold text-slate-900" data-id="element-5297" data-mp="35wn9lemk7tuy">
                    Réponse envoyée au citoyen
                  </div>
                  <div className="text-xs text-slate-500 mt-0.5" data-id="element-5298" data-mp="2e5pfq78gi37w">
                    Jacques Dubois (Travaux publics)
                  </div>
                  <div className="text-xs text-slate-400 mt-0.5" data-id="element-5299" data-mp="2987ez44leuaz">
                    19 mai 2026 · 09:47
                  </div>
                </div>
                <div className="relative pl-6" data-id="element-5300" data-mp="2i7kjdidv0sou">
                  <div className="absolute -left-[9px] top-1 w-4 h-4 rounded-full bg-amber-500 border-2 border-white" data-id="element-5301" data-mp="2i6ssulz4dl5f"></div>
                  <div className="text-sm font-semibold text-slate-900" data-id="element-5302" data-mp="2ij4igjd4y2i">
                    Statut changé de « Reçue » à « En cours »
                  </div>
                  <div className="text-xs text-slate-500 mt-0.5" data-id="element-5303" data-mp="5xauibpf8lhb">
                    Jacques Dubois (Travaux publics)
                  </div>
                  <div className="text-xs text-slate-400 mt-0.5" data-id="element-5304" data-mp="9xurnf9zvp3g">
                    19 mai 2026 · 09:30
                  </div>
                </div>
                <div className="relative pl-6" data-id="element-5305" data-mp="yhjcpxlx6kb">
                  <div className="absolute -left-[9px] top-1 w-4 h-4 rounded-full bg-emerald-500 border-2 border-white" data-id="element-5306" data-mp="11dgwd5jlt88"></div>
                  <div className="text-sm font-semibold text-slate-900" data-id="element-5307" data-mp="tnoow8vhawf2">
                    Requête assignée aux Travaux publics
                  </div>
                  <div className="text-xs text-slate-500 mt-0.5" data-id="element-5308" data-mp="eys7hl7j871s">
                    Sylvie Tremblay (Réception)
                  </div>
                  <div className="text-xs text-slate-400 mt-0.5" data-id="element-5309" data-mp="17nzhphgcml2v">
                    19 mai 2026 · 08:41
                  </div>
                </div>
                <div className="relative pl-6" data-id="element-5310" data-mp="1cg0qgteb5to5">
                  <div className="absolute -left-[9px] top-1 w-4 h-4 rounded-full bg-slate-300 border-2 border-white" data-id="element-5311" data-mp="1ma6attu853nm"></div>
                  <div className="text-sm font-semibold text-slate-900" data-id="element-5312" data-mp="1hb22f5f4j9yc">
                    Requête déposée avec deux photos
                  </div>
                  <div className="text-xs text-slate-500 mt-0.5" data-id="element-5313" data-mp="1cebk0bfuk29r">
                    Nathalie Ouellet (Application bciti+)
                  </div>
                  <div className="text-xs text-slate-400 mt-0.5" data-id="element-5314" data-mp="13btxrx06z9mr">
                    19 mai 2026 · 08:12
                  </div>
                </div>
              </div>
            </div>}

          <div className={`p-6 overflow-y-auto flex-1 space-y-6 ${rightTab === 'gestion' ? '' : 'hidden'}`} data-id="element-5315" data-mp="tkzff3q2gu6l">
            <div className="text-sm text-slate-500 font-medium" data-id="element-5316" data-mp="oohb24ynexus">
              19 mai <span className="mx-2 text-slate-300" data-id="element-5317" data-mp="kk17iacic2iq">→</span>{' '}
              <span className="text-red-500" data-id="element-5318" data-mp="fm81bhb7f8ig">26 mai</span>
            </div>

            {/* Tasks */}
            <div className="space-y-3" data-id="element-5319" data-mp="2r9lachsmicgh">
              <div className="flex items-start gap-3" data-id="element-5320" data-mp="2r8jodia2k5jz">
                <CheckSquareIcon className="w-5 h-5 text-slate-900 mt-0.5" data-id="element-5321" data-mp="2w860foe5vfr7" />
                <div className="flex-1" data-id="element-5322" data-mp="2wa91d3guqtap">
                  <div className="text-sm text-slate-500 line-through" data-id="element-5323" data-mp="309rn21ghz8el">
                    Vérifier la disponibilité des équipes
                  </div>
                  <div className="text-xs text-slate-400 mt-0.5" data-id="element-5324" data-mp="357023t6cmwbm">
                    Terminée: 22 mai 2026{' '}
                    <PencilIcon className="w-3 h-3 inline ml-1" data-id="element-5325" data-mp="2ckf449vdblz3" />
                  </div>
                </div>
                <div className="text-xs text-red-500 flex items-center gap-1" data-id="element-5326" data-mp="2hjryrgshdxc8">
                  <CalendarIcon className="w-3 h-3" data-id="element-5327" data-mp="2hhozs79cotvd" /> 22 mai 2026
                </div>
                <div className="w-6 h-6 rounded-full bg-indigo-500 text-white flex items-center justify-center text-[10px] font-bold" data-id="element-5328" data-mp="2mcbfgmmgt8l9">
                  ML
                </div>
              </div>
              <div className="flex items-start gap-3" data-id="element-5329" data-mp="1trupnxgf1jet">
                <SquareIcon className="w-5 h-5 text-slate-300 mt-0.5" data-id="element-5330" data-mp="af60szstpyb" />
                <div className="flex-1" data-id="element-5331" data-mp="3rhrqphzw4liz">
                  <div className="text-sm text-slate-700" data-id="element-5332" data-mp="3rit1dlczv606">
                    Planifier le ramassage des branches
                  </div>
                </div>
                <div className="text-xs text-red-500 flex items-center gap-1" data-id="element-5333" data-mp="4d24hcqz694h">
                  <CalendarIcon className="w-3 h-3" data-id="element-5334" data-mp="4az3xys74xli" /> 25 mai 2026
                </div>
                <div className="w-6 h-6 rounded-full bg-[#4F46E5] text-white flex items-center justify-center text-[10px] font-bold" data-id="element-5335" data-mp="j3sv4hgtz260">
                  ST
                </div>
              </div>
              <div className="flex items-start gap-3" data-id="element-5336" data-mp="s0a9dtkhrg5z">
                <SquareIcon className="w-5 h-5 text-slate-300 mt-0.5" data-id="element-5337" data-mp="o0j8gx193jnq" />
                <div className="flex-1" data-id="element-5338" data-mp="2tthmqxgjnnp8">
                  <div className="text-sm text-slate-700" data-id="element-5339" data-mp="2tuj1bbwrqsbp">
                    Contacter le demandeur pour suivi
                  </div>
                </div>
                <div className="text-xs text-red-500 flex items-center gap-1" data-id="element-5340" data-mp="2fohe1cpixp53">
                  <CalendarIcon className="w-3 h-3" data-id="element-5341" data-mp="2fqlf7mw1ga1o" /> 20 mai 2026
                </div>
                <div className="w-6 h-6 rounded-full border border-dashed border-slate-300 text-slate-400 flex items-center justify-center text-[10px]" data-id="element-5342" data-mp="2jrx5zvqnf1bg">
                  <UserIcon className="w-3 h-3" data-id="element-5343" data-mp="2awpmozyjnfdw" />
                </div>
              </div>
              <button className="text-sm text-slate-500 font-medium flex items-center gap-1 hover:text-slate-700 mt-2" data-id="element-5344" data-mp="1vzqdj7o1nehb">
                <PlusIcon className="w-4 h-4" data-id="element-5345" data-mp="2104e64nbfm5b" /> Ajouter une tâche
              </button>
            </div>

            {/* Linked Requests */}
            <div className="bg-white rounded-xl border border-slate-200 p-5" data-id="element-5346" data-mp="1n1wngegvhh2l">
              <h3 className="text-xs font-bold text-slate-400 uppercase tracking-wider mb-4" data-id="element-5347" data-mp="1rywqshmc85q0">
                REQUÊTES LIÉES
              </h3>
              <div className="space-y-3" data-id="element-5348" data-mp="3mceaftjmgifr">
                <div className="flex items-center justify-between p-2 hover:bg-slate-50 rounded-lg border border-transparent hover:border-slate-100 transition-colors" data-id="element-5349" data-mp="3mc5tnqkdosza">
                  <div className="flex items-center gap-3" data-id="element-5350" data-mp="3fw5y5ga4pjzo">
                    <span className="text-xs font-medium text-slate-500 bg-slate-100 px-2 py-1 rounded border border-slate-200" data-id="element-5351" data-mp="3fys45bhdfrfs">
                      Liée ▾
                    </span>
                    <span className="text-xs font-medium text-slate-500 bg-slate-100 px-2 py-1 rounded border border-slate-200" data-id="element-5352" data-mp="360ce7bu2yo7v">
                      R-68 ↗
                    </span>
                    <span className="text-sm text-slate-700" data-id="element-5353" data-mp="2i186rtf000x">
                      Lampadaire défectueux
                    </span>
                  </div>
                  <div className={`px-2 py-0.5 rounded-full text-xs font-medium flex items-center gap-1.5 ${getStatusColor('En Attente')}`} data-id="element-5354" data-mp="3oxlzyzmvodsa">
                    <div className={`w-1.5 h-1.5 rounded-full ${getStatusDot('En Attente')}`} data-id="element-5355" data-mp="lgdjok7stlzo"></div>
                    En Attente
                  </div>
                </div>
                <div className="flex items-center justify-between p-2 hover:bg-slate-50 rounded-lg border border-transparent hover:border-slate-100 transition-colors" data-id="element-5356" data-mp="xq36vyo1f8bm">
                  <div className="flex items-center gap-3" data-id="element-5357" data-mp="12s28p444px6g">
                    <span className="text-xs font-medium text-slate-500 bg-slate-100 px-2 py-1 rounded border border-slate-200" data-id="element-5358" data-mp="17pk9g77zt63d">
                      Bloque ▾
                    </span>
                    <span className="text-xs font-medium text-slate-500 bg-slate-100 px-2 py-1 rounded border border-slate-200" data-id="element-5359" data-mp="1gofh7nqoqo8s">
                      R-72 ↗
                    </span>
                    <span className="text-sm text-slate-700" data-id="element-5360" data-mp="1qfjv0k4mk321">
                      Nid-de-poule rue Principale
                    </span>
                  </div>
                  <div className={`px-2 py-0.5 rounded-full text-xs font-medium flex items-center gap-1.5 ${getStatusColor('Reçue')}`} data-id="element-5361" data-mp="1vck2mzh4hdv9">
                    <div className={`w-1.5 h-1.5 rounded-full ${getStatusDot('Reçue')}`} data-id="element-5362" data-mp="2kp3ta2ldnseb"></div>
                    Reçue
                  </div>
                </div>
                <div className="flex items-center justify-between p-2 hover:bg-slate-50 rounded-lg border border-transparent hover:border-slate-100 transition-colors" data-id="element-5363" data-mp="2un0ejn8143q5">
                  <div className="flex items-center gap-3" data-id="element-5364" data-mp="2217893niy6ym">
                    <span className="text-xs font-medium text-slate-500 bg-slate-100 px-2 py-1 rounded border border-slate-200" data-id="element-5365" data-mp="1x1m84pwmbskb">
                      Doublon ▾
                    </span>
                    <span className="text-xs font-medium text-slate-500 bg-slate-100 px-2 py-1 rounded border border-slate-200" data-id="element-5366" data-mp="26ziihfhqejhd">
                      R-75 ↗
                    </span>
                    <span className="text-sm text-slate-700" data-id="element-5367" data-mp="1j7uwnbzbtyly">
                      Banc de parc endommagé
                    </span>
                  </div>
                  <div className={`px-2 py-0.5 rounded-full text-xs font-medium flex items-center gap-1.5 ${getStatusColor('En Cours')}`} data-id="element-5368" data-mp="3px5anz64w7fl">
                    <div className={`w-1.5 h-1.5 rounded-full ${getStatusDot('En Cours')}`} data-id="element-5369" data-mp="3gy1qssz57o01"></div>
                    En Cours
                  </div>
                </div>
              </div>
              <button className="text-sm text-slate-500 font-medium flex items-center gap-1 hover:text-slate-700 mt-3" data-id="element-5370" data-mp="cklciskcnsb0">
                <PlusIcon className="w-4 h-4" data-id="element-5371" data-mp="hgaipeqvk7ga" /> Lier une requête
              </button>
            </div>

            {/* Tags */}
            <div className="bg-white rounded-xl border border-slate-200 p-5" data-id="element-5372" data-mp="8hgdizzha8r4">
              <h3 className="text-xs font-bold text-slate-400 uppercase tracking-wider mb-4" data-id="element-5373" data-mp="8jjdocuchi9k">
                ÉTIQUETTES
              </h3>
              <div className="flex flex-wrap gap-2" data-id="element-5374" data-mp="2t87fwgydw9if">
                <span className="px-3 py-1 rounded-full bg-indigo-50 text-indigo-600 text-xs font-medium border border-indigo-100 flex items-center gap-1" data-id="element-5375" data-mp="2t5urpm2192wx">
                  Urgent <XIcon className="w-3 h-3 cursor-pointer" data-id="element-5376" data-mp="2hspfn7gehcpp" />
                </span>
                <span className="px-3 py-1 rounded-full bg-indigo-50 text-indigo-600 text-xs font-medium border border-indigo-100 flex items-center gap-1" data-id="element-5377" data-mp="233szso83qvej">
                  Suivi requis <XIcon className="w-3 h-3 cursor-pointer" data-id="element-5378" data-mp="2vrp0e40sl7gl" />
                </span>
                <button className="px-3 py-1 rounded-full border border-dashed border-slate-300 text-slate-500 text-xs font-medium flex items-center gap-1 hover:border-slate-400 hover:text-slate-700 transition-colors" data-id="element-5379" data-mp="2vpui6xgwntg7">
                  <PlusIcon className="w-3 h-3" data-id="element-5380" data-mp="2qsc6x0ff1251" /> Ajouter une étiquette
                </button>
              </div>
            </div>

            {/* Internal Files */}
            <div className="bg-white rounded-xl border border-slate-200 p-5" data-id="element-5381" data-mp="1aggnd6vno3yy">
              <h3 className="text-xs font-bold text-slate-400 uppercase tracking-wider mb-4" data-id="element-5382" data-mp="1ff07r2ulp7p7">
                FICHIERS INTERNES
              </h3>
              <div className="flex gap-3" data-id="element-5383" data-mp="3omdfh4euouvb">
                <div className="w-20 rounded-lg border border-slate-200 p-2 flex flex-col items-center justify-center text-center" data-id="element-5384" data-mp="3olbsc1kk8hx8">
                  <FileTextIcon className="w-8 h-8 text-red-500 mb-2" data-id="element-5385" data-mp="6e5vnsdsm4pz" />
                  <div className="text-[10px] font-medium text-slate-700 truncate w-full" data-id="element-5386" data-mp="2feth6ugzww0">
                    rapport_inspe...
                  </div>
                  <div className="text-[9px] text-slate-400" data-id="element-5387" data-mp="35vvqnax52jf8">22 mai</div>
                </div>
                <div className="w-20 h-24 rounded-lg bg-slate-200 overflow-hidden" data-id="element-5388" data-mp="3jms57xu8d03a">
                  <img src="https://images.unsplash.com/photo-1464822759023-fed622ff2c3b?w=200&h=200&fit=crop" alt="Doc" className="w-full h-full object-cover" data-id="element-5389" data-mp="3jov1gzlz7pgg" />
                </div>
                <div className="w-20 h-24 rounded-lg bg-slate-200 overflow-hidden" data-id="element-5390" data-mp="2n4mfyybmtom2">
                  <img src="https://images.unsplash.com/photo-1518495973542-4542c06a5843?w=200&h=200&fit=crop" alt="Doc" className="w-full h-full object-cover" data-id="element-5391" data-mp="q3gn0r9hs0bu" />
                </div>
                <button className="w-20 h-24 rounded-lg border-2 border-dashed border-slate-300 flex flex-col items-center justify-center text-slate-400 hover:text-[#4F46E5] hover:border-[#4F46E5] transition-colors" data-id="element-5392" data-mp="14teb777f8q11">
                  <PlusIcon className="w-5 h-5 mb-1" data-id="element-5393" data-mp="c474vm1q6w58" />
                  <span className="text-xs font-medium" data-id="element-5394" data-mp="c6tbnjgsl7me">Téléverser</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>;
  }
  return <div className="bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden" data-id="element-5395" data-mp="m47tnnid64gt">
      {/* Header */}
      <div className="p-4 border-b border-slate-200" data-id="element-5396" data-mp="1slbdo7oze5ph">
        <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4" data-id="element-5397" data-mp="1xh0j2rnomgtp">
          <div className="flex items-center gap-3" data-id="element-5398" data-mp="3hz2l2g60ufee">
            <div className="inline-flex items-center bg-slate-100 rounded-lg p-1 gap-1" data-id="element-5399" data-mp="3i1x4q5h7nw6r">
              <button onClick={() => setViewMode('list')} className={`flex items-center gap-2 px-3 py-1.5 rounded-md text-sm font-semibold transition-colors ${viewMode === 'list' ? 'bg-white shadow-sm text-slate-900' : 'text-slate-500 hover:text-slate-700'}`} data-id="element-5400" data-mp="3d340z4rq7jjs">
                <TableIcon className="w-4 h-4" data-id="element-5401" data-mp="2y9s8hb1koaki" />
                Tableau
              </button>
              <button onClick={() => setViewMode('map')} className={`flex items-center gap-2 px-3 py-1.5 rounded-md text-sm font-semibold transition-colors ${viewMode === 'map' ? 'bg-white shadow-sm text-slate-900' : 'text-slate-500 hover:text-slate-700'}`} data-id="element-5402" data-mp="2ucw5n8u9pxe5">
                <MapIcon className="w-4 h-4" data-id="element-5403" data-mp="ikz7o4expray" />
                Carte
              </button>
            </div>
            <span className="text-sm text-slate-500" data-id="element-5404" data-mp="3ccytcblqfnn9">10 demandes</span>
          </div>

          <div className="flex items-center gap-3" data-id="element-5405" data-mp="3cb4bj65rcbne">
            <div className="relative" data-id="element-5406" data-mp="3gd919tt34o4r">
              <SearchIcon className="w-4 h-4 text-slate-400 absolute left-3 top-1/2 -translate-y-1/2" data-id="element-5407" data-mp="3gc7pto85pzmi" />
              <input type="text" placeholder="Rechercher des requêtes..." className="pl-9 pr-4 py-2 border border-slate-200 rounded-lg text-sm w-64 focus:outline-none focus:ring-2 focus:ring-[#4F46E5] focus:border-transparent" data-id="element-5408" data-mp="32h57u2q1cjtc" />
            </div>
            <button className="flex items-center gap-2 px-4 py-2 bg-white border border-slate-200 text-slate-700 text-sm font-semibold rounded-lg hover:bg-slate-50 transition-colors" data-id="element-5409" data-mp="2jo9tsh0brqdm">
              <FilterIcon className="w-4 h-4" data-id="element-5410" data-mp="2ol05ks53jzt8" />
              Filtrer
            </button>
            <button onClick={() => setShowCreate(true)} className="flex items-center gap-2 px-4 py-2 bg-slate-900 text-white text-sm font-semibold rounded-lg hover:bg-slate-800 transition-colors whitespace-nowrap" data-id="element-5411" data-mp="29s6qh7tqllp3">
              <PlusIcon className="w-4 h-4" data-id="element-5412" data-mp="1r2ux6zj97div" />
              Créer une requête
            </button>
          </div>
        </div>
      </div>

      {/* Map View */}
      {viewMode === 'map' && <div className="h-[400px] w-full border-b border-slate-200" data-id="element-5413" data-mp="20285vpzjzy2j">
          <MapContainer center={[45.4499, -73.4653]} zoom={13} scrollWheelZoom={false} style={{
        height: '100%',
        width: '100%'
      }} data-id="element-5414" data-mp="2e297j7nn79j2">
            <TileLayer attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>' url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" data-id="element-5415" data-mp="2nsc2hdebqxk1" />
            {MAP_MARKERS.map(m => <Marker key={m.reqId} position={m.position} icon={requestMarkerIcon} data-id="element-5416" data-mp="2xnvtble1761x">
                <Popup data-id="element-5417" data-mp="2zvemjuqpkt4s">
                  <div className="text-sm" data-id="element-5418" data-mp="2zvy6fgzx5rlg">
                    <div className="font-semibold text-slate-900" data-id="element-5419" data-mp="34t6oziozbxn8">
                      {m.reqId} — {m.subject}
                    </div>
                    <div className="text-slate-500" data-id="element-5420" data-mp="39rrfgqefj2yh">{m.category}</div>
                  </div>
                </Popup>
              </Marker>)}
          </MapContainer>
        </div>}

      {/* Table */}
      <div className="overflow-x-auto" data-id="element-5421" data-mp="3ji2v3a7h70l7">
        <table className="w-full text-left border-collapse" data-id="element-5422" data-mp="3njo2ig18qmo0">
          <thead data-id="element-5423" data-mp="3ni4o6uz5alov">
            <tr className="border-b border-slate-200 bg-white" data-id="element-5424" data-mp="3nlsj9yk8ng5p">
              <th className="px-4 py-3 text-xs font-semibold text-slate-500 whitespace-nowrap" data-id="element-5425" data-mp="3sjk8gkti0o67">
                <span className="inline-flex items-center gap-1" data-id="element-5426" data-mp="1beoffws25df">
                  Sujet{' '}
                  <ChevronsUpDownIcon className="w-3.5 h-3.5 text-slate-400" data-id="element-5427" data-mp="1y6b4t9nmvwvv" />
                </span>
              </th>
              <th className="px-4 py-3 text-xs font-semibold text-slate-500 whitespace-nowrap" data-id="element-5428" data-mp="234conwsvw08e">
                <span className="inline-flex items-center gap-1" data-id="element-5429" data-mp="1vlwfelotzssi">
                  Catégorie{' '}
                  <ChevronsUpDownIcon className="w-3.5 h-3.5 text-slate-400" data-id="element-5430" data-mp="1qsk3nc593gh6" />
                </span>
              </th>
              <th className="px-4 py-3 text-xs font-semibold text-slate-500 whitespace-nowrap" data-id="element-5431" data-mp="1lsfiv9xb7zl5">
                <span className="inline-flex items-center gap-1" data-id="element-5432" data-mp="1gtuhh76bn9v4">
                  ID Requête{' '}
                  <ChevronsUpDownIcon className="w-3.5 h-3.5 text-slate-400" data-id="element-5433" data-mp="2eh39ll0tvh63" />
                </span>
              </th>
              <th className="px-4 py-3 text-xs font-semibold text-slate-500 whitespace-nowrap" data-id="element-5434" data-mp="24kzznszqie8l">
                Emplacement
              </th>
              <th className="px-4 py-3 text-xs font-semibold text-slate-500 whitespace-nowrap" data-id="element-5435" data-mp="1zldn7lrqd20u">
                <span className="inline-flex items-center gap-1" data-id="element-5436" data-mp="t6w4wklbom2h">
                  Date de création{' '}
                  <ChevronsUpDownIcon className="w-3.5 h-3.5 text-slate-400" data-id="element-5437" data-mp="o5glewysmnm7" />
                </span>
              </th>
              <th className="px-4 py-3 text-xs font-semibold text-slate-500 whitespace-nowrap" data-id="element-5438" data-mp="1dx8i505a3sl9">
                <span className="inline-flex items-center gap-1" data-id="element-5439" data-mp="1is5lbqfvn7q8">
                  Statut{' '}
                  <ChevronsUpDownIcon className="w-3.5 h-3.5 text-slate-400" data-id="element-5440" data-mp="14wk1rysexg57" />
                </span>
              </th>
              <th className="px-4 py-3 text-xs font-semibold text-slate-500 whitespace-nowrap" data-id="element-5441" data-mp="1wln6ffo7osid">
                <span className="inline-flex items-center gap-1" data-id="element-5442" data-mp="1wnznzrq250uw">
                  Département{' '}
                  <ChevronsUpDownIcon className="w-3.5 h-3.5 text-slate-400" data-id="element-5443" data-mp="1ntbhjy8qxd4i" />
                </span>
              </th>
              <th className="px-4 py-3 text-xs font-semibold text-slate-500 whitespace-nowrap" data-id="element-5444" data-mp="1ruevgf78gz33">
                Demandeur
              </th>
              <th className="px-4 py-3 text-xs font-semibold text-slate-500 whitespace-nowrap" data-id="element-5445" data-mp="2fiy631dr9nyc">
                Date SLA
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-100" data-id="element-5446" data-mp="8vh283grshhg">
            {MOCK_REQUESTS.map(req => <tr key={req.id} onClick={() => setSelectedRequest(req)} className="hover:bg-slate-50 cursor-pointer transition-colors" data-id="element-5447" data-mp="3w4dfd6c90c8">
                <td className="px-4 py-3 text-sm text-slate-700 whitespace-nowrap" data-id="element-5448" data-mp="do0caqg90uhi">
                  <div className="flex items-center gap-2" data-id="element-5449" data-mp="3m28z1hw3ar1r">
                    <div className="w-8 h-8 rounded bg-slate-50 border border-slate-200 flex items-center justify-center" data-id="element-5450" data-mp="3m4v85lympem3">
                      <FolderIcon className="w-4 h-4 text-[#4F46E5]" data-id="element-5451" data-mp="3w0orpparm8dd" />
                    </div>
                    {req.subject}
                  </div>
                </td>
                <td className="px-4 py-3 text-sm text-slate-600 whitespace-nowrap" data-id="element-5452" data-mp="3r3yct5ap5itj">
                  {req.category}
                </td>
                <td className="px-4 py-3 text-sm text-slate-600 whitespace-nowrap" data-id="element-5453" data-mp="16c5ylhmyarjg">
                  {req.reqId}
                </td>
                <td className="px-4 py-3 text-sm text-slate-600 whitespace-nowrap" data-id="element-5454" data-mp="1kzse6metf0t9">
                  <div className="flex items-center gap-1" data-id="element-5455" data-mp="1fy3356rlen56">
                    {req.location}
                    <MapPinIcon className="w-3 h-3 text-[#4F46E5]" data-id="element-5456" data-mp="1b12rmgbz4s6o" />
                  </div>
                </td>
                <td className="px-4 py-3 text-sm text-slate-600 whitespace-nowrap" data-id="element-5457" data-mp="16zr9swzcdb91">
                  {req.date}
                </td>
                <td className="px-4 py-3 whitespace-nowrap" data-id="element-5458" data-mp="23qjjncvom72d">
                  <div className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium ${getStatusColor(req.status)}`} data-id="element-5459" data-mp="1yqx4gxwamgqx">
                    <div className={`w-1.5 h-1.5 rounded-full ${getStatusDot(req.status)}`} data-id="element-5460" data-mp="1pw91xfi3rd5t"></div>
                    {req.status}
                  </div>
                </td>
                <td className="px-4 py-3 text-sm text-slate-600 whitespace-nowrap" data-id="element-5461" data-mp="2hmx0qkwb06gb">
                  {req.department}
                </td>
                <td className="px-4 py-3 text-sm text-slate-600 whitespace-nowrap" data-id="element-5462" data-mp="94x48jqr27dt">
                  <div className="flex items-center gap-2" data-id="element-5463" data-mp="971851onf6e3">
                    <div className={`w-6 h-6 rounded-full ${req.requester.color} text-white flex items-center justify-center text-[10px] font-bold`} data-id="element-5464" data-mp="d5qrdawdbi5n">
                      {req.requester.initials}
                    </div>
                    {req.requester.name}
                  </div>
                </td>
                <td className="px-4 py-3 text-sm text-slate-600 whitespace-nowrap" data-id="element-5465" data-mp="wuhnz4uq98o5">
                  {req.slaDate}
                </td>
              </tr>)}
          </tbody>
        </table>
      </div>

      {/* Pagination */}
      <div className="p-4 border-t border-slate-200 flex items-center justify-end gap-6 text-sm text-slate-500" data-id="element-5466" data-mp="15w8s459md7fw">
        <div className="flex items-center gap-2" data-id="element-5467" data-mp="1av2947o47gkt">
          Éléments par page
          <select className="border-b border-slate-300 pb-1 focus:outline-none bg-transparent font-medium text-slate-700" data-id="element-5468" data-mp="36wnibr60dbqf">
            <option data-id="element-5469" data-mp="31zx1h1mdqc3y">10</option>
            <option data-id="element-5470" data-mp="31whj9pxesmyb">20</option>
            <option data-id="element-5471" data-mp="3gnqimqr45mon">50</option>
          </select>
        </div>
        <div data-id="element-5472" data-mp="3gpbcee5lt1lg">1 - 10 / 98</div>
        <div className="flex items-center gap-4" data-id="element-5473" data-mp="3bwrvp8bmdqcf">
          <button className="hover:text-slate-900" data-id="element-5474" data-mp="3bv73vqgowli9">
            <ChevronLeftIcon className="w-4 h-4" data-id="element-5475" data-mp="3pndih8472kfl" />
          </button>
          <button className="hover:text-slate-900" data-id="element-5476" data-mp="3pprepkam22oq">
            <ChevronRightIcon className="w-4 h-4" data-id="element-5477" data-mp="3ll9x9rrq41h4" />
          </button>
        </div>
      </div>

      {showCreate && <CreateRequeteDialog onClose={() => setShowCreate(false)} data-id="element-5478" data-mp="3g6nvuuq53aw" />}
    </div>;
}
// Missing icons for the component
function CalendarIcon(props: React.SVGProps<SVGSVGElement>) {
  return <svg {...props} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-5479" data-mp="258l9p50e2rwl">
      <rect width="18" height="18" x="3" y="4" rx="2" ry="2" data-id="element-5480" data-mp="kqkc8nswomus" />
      <line x1="16" x2="16" y1="2" y2="6" data-id="element-5481" data-mp="krve2i2sjkj9" />
      <line x1="8" x2="8" y1="2" y2="6" data-id="element-5482" data-mp="61weqbzi2327" />
      <line x1="3" x2="21" y1="10" y2="10" data-id="element-5483" data-mp="5z1xsufp30dj" />
    </svg>;
}
function UserIcon(props: React.SVGProps<SVGSVGElement>) {
  return <svg {...props} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-5484" data-mp="3t63yh2v5t50c">
      <path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2" data-id="element-5485" data-mp="3j9hfykqb2q1h" />
      <circle cx="12" cy="7" r="4" data-id="element-5486" data-mp="3o5y3pdtlf2e1" />
    </svg>;
}
function PencilIcon(props: React.SVGProps<SVGSVGElement>) {
  return <svg {...props} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-5487" data-mp="1hhl41a087e66">
      <path d="M17 3a2.85 2.83 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5Z" data-id="element-5488" data-mp="3eh7a37m7ft5n" />
      <path d="m15 5 4 4" data-id="element-5489" data-mp="3eetbiosbfytc" />
    </svg>;
}